module.exports = __webpack_public_path__ + "media/images/lb/705-a18e00458fdf457f5e8d16514fcd09f4.svg";